/**
 * The join-code vocabulary. Exactly 1024 words, so a four-word code is exactly
 * 40 bits and maps bijectively onto an integer - which makes codes testable
 * rather than merely plausible.
 *
 * GENERATED AND FROZEN. Adding, removing or reordering a word changes what
 * every existing code decodes to, so this list is protocol, not content. A new
 * vocabulary needs a new protocol version.
 *
 * Selection criteria: 3-4 letters (mobile autocomplete and autocorrect fight
 * you on anything longer), concrete, speakable across a noisy table, and
 * spellable by someone who has only heard it once.
 */
export const WORDLIST: readonly string[] = [
  'ace',
  'acer',
  'ache',
  'acid',
  'adit',
  'age',
  'ages',
  'aims',
  'aka',
  'amp',
  'ant',
  'anti',
  'ape',
  'apex',
  'arc',
  'arch',
  'arid',
  'arm',
  'arms',
  'army',
  'arts',
  'ash',
  'asia',
  'atom',
  'auk',
  'aunt',
  'awl',
  'axe',
  'axle',
  'baby',
  'bad',
  'bag',
  'bake',
  'ball',
  'ban',
  'band',
  'bang',
  'bar',
  'bard',
  'bark',
  'barn',
  'bars',
  'bass',
  'bat',
  'bath',
  'bay',
  'bead',
  'beak',
  'beam',
  'bean',
  'bear',
  'beat',
  'bed',
  'beds',
  'bee',
  'beef',
  'beer',
  'beet',
  'bell',
  'belt',
  'bend',
  'bent',
  'berm',
  'bet',
  'bias',
  'bid',
  'big',
  'bike',
  'bin',
  'bind',
  'bio',
  'bird',
  'bit',
  'blue',
  'boa',
  'boat',
  'body',
  'bog',
  'boil',
  'bold',
  'bolt',
  'bone',
  'book',
  'boom',
  'boot',
  'boss',
  'bow',
  'bowl',
  'box',
  'bran',
  'brew',
  'brie',
  'brig',
  'brim',
  'brow',
  'buck',
  'bud',
  'bull',
  'bun',
  'burn',
  'bust',
  'buzz',
  'byre',
  'byte',
  'cab',
  'cafe',
  'cake',
  'cal',
  'calf',
  'calm',
  'cam',
  'camp',
  'cams',
  'cap',
  'cape',
  'caps',
  'car',
  'card',
  'care',
  'carp',
  'cars',
  'cart',
  'case',
  'cash',
  'cask',
  'cast',
  'cat',
  'cats',
  'cave',
  'cell',
  'char',
  'chef',
  'chin',
  'chip',
  'chop',
  'chub',
  'clam',
  'claw',
  'clay',
  'clip',
  'club',
  'coal',
  'coat',
  'cod',
  'code',
  'cog',
  'coil',
  'coin',
  'coke',
  'col',
  'cold',
  'cole',
  'comb',
  'cone',
  'cool',
  'coop',
  'coot',
  'cop',
  'cord',
  'core',
  'cork',
  'corn',
  'cosy',
  'cot',
  'cove',
  'cow',
  'cowl',
  'crab',
  'crag',
  'crib',
  'crop',
  'crow',
  'cry',
  'cub',
  'cube',
  'cue',
  'cuff',
  'cup',
  'curd',
  'curl',
  'cute',
  'cuts',
  'cyan',
  'dale',
  'dam',
  'dame',
  'damp',
  'dank',
  'dark',
  'dart',
  'dash',
  'data',
  'date',
  'dawn',
  'days',
  'deal',
  'dear',
  'deck',
  'deep',
  'deer',
  'dell',
  'den',
  'dent',
  'desk',
  'dew',
  'dial',
  'dice',
  'diet',
  'dike',
  'dill',
  'dim',
  'dime',
  'dirt',
  'disc',
  'dish',
  'disk',
  'dive',
  'dock',
  'doe',
  'dog',
  'dogs',
  'doll',
  'dome',
  'doom',
  'door',
  'dorm',
  'dory',
  'dose',
  'dot',
  'dove',
  'down',
  'drag',
  'draw',
  'drop',
  'drum',
  'dry',
  'duck',
  'duke',
  'dull',
  'dune',
  'duo',
  'dusk',
  'dust',
  'dyke',
  'earl',
  'ears',
  'east',
  'eat',
  'eave',
  'echo',
  'eddy',
  'edge',
  'eel',
  'eft',
  'egg',
  'elf',
  'elk',
  'elm',
  'emu',
  'end',
  'eng',
  'era',
  'etch',
  'eve',
  'ewe',
  'exit',
  'eye',
  'eyed',
  'eyes',
  'fact',
  'fair',
  'fame',
  'faqs',
  'farm',
  'fat',
  'fate',
  'fawn',
  'feet',
  'fell',
  'felt',
  'fen',
  'fern',
  'feta',
  'fife',
  'fig',
  'file',
  'film',
  'find',
  'fine',
  'fir',
  'fire',
  'firm',
  'fish',
  'fist',
  'flag',
  'flan',
  'flap',
  'flat',
  'flea',
  'flip',
  'flow',
  'flu',
  'fly',
  'foal',
  'foam',
  'fog',
  'fold',
  'folk',
  'food',
  'foot',
  'ford',
  'fork',
  'fort',
  'foul',
  'fox',
  'fret',
  'frog',
  'fry',
  'fuel',
  'fume',
  'fund',
  'fur',
  'fuse',
  'gale',
  'game',
  'gasp',
  'gate',
  'gave',
  'gay',
  'gear',
  'gel',
  'gem',
  'gene',
  'ghee',
  'gift',
  'girl',
  'glad',
  'glen',
  'glow',
  'glue',
  'glum',
  'gnat',
  'goal',
  'goat',
  'gods',
  'gold',
  'golf',
  'gong',
  'goo',
  'gown',
  'grab',
  'gray',
  'grew',
  'grey',
  'grid',
  'grip',
  'grit',
  'grow',
  'gulf',
  'gull',
  'gum',
  'gust',
  'guy',
  'guys',
  'gym',
  'hail',
  'hair',
  'hake',
  'half',
  'hall',
  'halt',
  'ham',
  'hand',
  'hang',
  'hard',
  'hare',
  'harp',
  'hash',
  'hasp',
  'hat',
  'hats',
  'hawk',
  'hay',
  'haze',
  'hazy',
  'head',
  'heap',
  'hear',
  'heat',
  'heel',
  'helm',
  'hem',
  'hen',
  'herb',
  'herd',
  'hero',
  'hide',
  'hill',
  'hilt',
  'hind',
  'hint',
  'hip',
  'hire',
  'hiss',
  'hive',
  'hoax',
  'hoe',
  'hog',
  'hood',
  'hoof',
  'hook',
  'hoop',
  'hoot',
  'hop',
  'hope',
  'horn',
  'hose',
  'host',
  'hot',
  'hour',
  'hub',
  'hug',
  'huge',
  'hull',
  'hum',
  'hump',
  'hunt',
  'hurt',
  'hush',
  'husk',
  'hut',
  'hymn',
  'ibex',
  'ibis',
  'ice',
  'icy',
  'idol',
  'inch',
  'ink',
  'inn',
  'iris',
  'iron',
  'isle',
  'itch',
  'ivy',
  'jade',
  'jam',
  'jar',
  'jaw',
  'jay',
  'jazz',
  'jest',
  'jet',
  'jets',
  'jig',
  'job',
  'jobs',
  'join',
  'joke',
  'jolt',
  'joy',
  'judo',
  'jug',
  'jump',
  'jury',
  'just',
  'jute',
  'kale',
  'keel',
  'keen',
  'keep',
  'keg',
  'kelp',
  'kept',
  'key',
  'keys',
  'kick',
  'kid',
  'kids',
  'kiln',
  'kilo',
  'kin',
  'kind',
  'king',
  'kiss',
  'kit',
  'kite',
  'kiwi',
  'knee',
  'knit',
  'knob',
  'knot',
  'koi',
  'lab',
  'lace',
  'lady',
  'lag',
  'lair',
  'lake',
  'lamb',
  'lamp',
  'land',
  'lane',
  'lap',
  'lard',
  'lark',
  'lash',
  'lava',
  'law',
  'lawn',
  'laws',
  'lead',
  'leaf',
  'leap',
  'leek',
  'leg',
  'legs',
  'lens',
  'levy',
  'lick',
  'lid',
  'lies',
  'life',
  'lift',
  'lily',
  'limb',
  'lime',
  'line',
  'ling',
  'link',
  'lion',
  'lip',
  'lips',
  'list',
  'load',
  'loaf',
  'loan',
  'loch',
  'lock',
  'lode',
  'loft',
  'log',
  'logs',
  'lone',
  'long',
  'loom',
  'loop',
  'loot',
  'lord',
  'lore',
  'lose',
  'loss',
  'lost',
  'loud',
  'lull',
  'lump',
  'lung',
  'lure',
  'lush',
  'lute',
  'lynx',
  'lyre',
  'mace',
  'mage',
  'male',
  'mall',
  'man',
  'mane',
  'map',
  'maps',
  'mare',
  'mark',
  'mars',
  'mart',
  'mash',
  'mask',
  'mast',
  'mat',
  'mate',
  'math',
  'meal',
  'meat',
  'mega',
  'melt',
  'memo',
  'men',
  'mere',
  'mesa',
  'mesh',
  'mess',
  'meta',
  'mica',
  'mice',
  'mild',
  'mile',
  'milk',
  'mill',
  'mind',
  'mine',
  'mini',
  'mink',
  'mint',
  'mire',
  'miss',
  'mist',
  'mite',
  'mitt',
  'moat',
  'mob',
  'mold',
  'mole',
  'moms',
  'monk',
  'moon',
  'moor',
  'mop',
  'moss',
  'moth',
  'mud',
  'mug',
  'mule',
  'mush',
  'musk',
  'nail',
  'name',
  'navy',
  'neat',
  'neck',
  'neon',
  'nest',
  'net',
  'newt',
  'nib',
  'nick',
  'nine',
  'nod',
  'node',
  'nook',
  'noon',
  'nose',
  'note',
  'nova',
  'nuke',
  'nut',
  'nuts',
  'oak',
  'oar',
  'oat',
  'oath',
  'oats',
  'oboe',
  'odd',
  'ode',
  'oil',
  'oils',
  'okra',
  'ones',
  'onyx',
  'opal',
  'open',
  'orca',
  'ore',
  'oval',
  'oven',
  'owl',
  'pace',
  'pack',
  'pact',
  'page',
  'pail',
  'pale',
  'palm',
  'pan',
  'pane',
  'pang',
  'par',
  'path',
  'pea',
  'peak',
  'peal',
  'pear',
  'peat',
  'pee',
  'peel',
  'peer',
  'peg',
  'pelt',
  'pen',
  'pens',
  'pest',
  'pet',
  'pets',
  'pick',
  'pics',
  'pie',
  'pier',
  'pig',
  'pike',
  'pile',
  'pill',
  'pin',
  'pine',
  'pink',
  'pint',
  'pip',
  'pipe',
  'pit',
  'pith',
  'plow',
  'plug',
  'plum',
  'plus',
  'pod',
  'poem',
  'poet',
  'pole',
  'pond',
  'pony',
  'pool',
  'pork',
  'port',
  'pose',
  'post',
  'pot',
  'pour',
  'prow',
  'pub',
  'puck',
  'pug',
  'pull',
  'puma',
  'pump',
  'punk',
  'punt',
  'pup',
  'purr',
  'push',
  'puts',
  'quay',
  'quiz',
  'race',
  'rack',
  'raft',
  'rage',
  'raid',
  'rail',
  'rain',
  'rake',
  'ram',
  'ramp',
  'ran',
  'rank',
  'rant',
  'rap',
  'rare',
  'rash',
  'rasp',
  'rat',
  'rate',
  'rats',
  'raw',
  'ray',
  'red',
  'reed',
  'reef',
  'reel',
  'ref',
  'rein',
  'rely',
  'rent',
  'rest',
  'rib',
  'ribs',
  'rice',
  'rich',
  'rick',
  'ride',
  'riff',
  'rill',
  'rim',
  'rime',
  'rind',
  'ring',
  'rink',
  'ripe',
  'rise',
  'risk',
  'rive',
  'road',
  'rob',
  'rock',
  'rod',
  'role',
  'roll',
  'roof',
  'rook',
  'room',
  'root',
  'rope',
  'rosa',
  'rose',
  'rot',
  'row',
  'ruby',
  'rug',
  'rule',
  'run',
  'rush',
  'rust',
  'rye',
  'sack',
  'sage',
  'sail',
  'sale',
  'salt',
  'sand',
  'sap',
  'sash',
  'saw',
  'scam',
  'scan',
  'scar',
  'sea',
  'seal',
  'seam',
  'seat',
  'sec',
  'seed',
  'seem',
  'seen',
  'sees',
  'sell',
  'serf',
  'sets',
  'sew',
  'shed',
  'shin',
  'ship',
  'shoe',
  'shot',
  'shut',
  'shy',
  'side',
  'sift',
  'sigh',
  'silk',
  'sill',
  'silo',
  'silt',
  'sing',
  'sink',
  'sir',
  'ski',
  'skin',
  'skip',
  'skis',
  'sky',
  'slab',
  'slam',
  'slap',
  'slat',
  'sled',
  'slim',
  'slug',
  'sly',
  'smog',
  'snap',
  'snow',
  'snug',
  'soap',
  'sock',
  'sofa',
  'soft',
  'sold',
  'sole',
  'solo',
  'soma',
  'song',
  'sons',
  'soot',
  'sort',
  'soup',
  'soy',
  'spin',
  'spit',
  'spry',
  'spur',
  'spy',
  'stag',
  'star',
  'stem',
  'stew',
  'stir',
  'sty',
  'sub',
  'sun',
  'surf',
  'swan',
  'swim',
  'taco',
  'tags',
  'tall',
  'tan',
  'tank',
  'tap',
  'tar',
  'tarn',
  'tart',
  'task',
  'tea',
  'teal',
  'team',
  'tear',
  'tee',
  'teen',
  'tent',
  'tern',
  'text',
  'thaw',
  'thin',
  'tick',
  'tide',
  'tidy',
  'tie',
  'tilt',
  'tin',
  'tire',
  'toad',
  'toe',
  'toll',
  'tone',
  'tong',
  'tons',
  'took',
  'tool',
  'top',
  'tops',
  'toy',
  'toys',
  'tray',
  'tree',
  'trek',
  'trim',
  'trip',
  'trot',
  'tub',
  'tuba',
  'tube',
  'tuck',
  'tug',
  'tuna',
  'tune',
  'turn',
  'twig',
  'ulna',
  'urge',
  'urn',
  'vale',
  'vane',
  'vary',
  'vase',
  'vat',
  'vein',
  'vest',
  'vine',
  'viol',
  'vise',
  'vole',
  'volt',
  'wage',
  'walk',
  'wall',
  'ware',
  'warm',
  'wars',
  'wash',
  'wasp',
  'wax',
  'waxy',
  'weak',
  'weed',
  'week',
  'weir',
  'weld',
  'well',
  'wet',
  'whey',
  'whip',
  'whir',
  'wick',
  'wide',
  'wife',
  'win',
  'wind',
  'wine',
  'wins',
  'wire',
  'wok',
  'wolf',
  'won',
  'wood',
  'wool',
  'word',
  'worm',
  'wow',
  'wrap',
  'wren',
  'yak',
  'yam',
  'yard',
  'yarn',
  'yawl',
  'yawn',
  'yew',
  'yoke',
  'yolk',
  'yoyo',
  'yurt',
  'zebu',
  'zest',
  'zinc',
  'zip',
  'zone',
  'zoo',
];

/** 1024 === 2 ** WORD_BITS. */
export const WORD_BITS = 10;
export const WORDS_PER_CODE = 4;
export const CODE_BITS = WORD_BITS * WORDS_PER_CODE;

const INDEX: ReadonlyMap<string, number> = new Map(WORDLIST.map((word, i) => [word, i]));

export function wordIndex(word: string): number | undefined {
  return INDEX.get(word);
}
